import { Rectangle, Color } from "cesium";

/// /// 3次メッシュ3列の可視化・デフォルト倍率設定の追加・20220218 /////////////////////////
export function mesh3rdRect(
  meshcode3rd,
  h,
  c,
  dataname,
  pagedata,
  shikii1,
  shikii2,
  shikii3,
  shikii4,
  hanrei1_color,
  hanrei2_color,
  hanrei3_color,
  hanrei4_color,
  hanrei5_color,
  ratio,
  alpha,
  defaultratio,
  year1_nihonsokuchi
) {
  var strMeshcoe = String(meshcode3rd);
  var p = parseInt(strMeshcoe.slice(0, 2));
  var u = parseInt(strMeshcoe.slice(2, 4));
  var q = parseInt(strMeshcoe.slice(4, 5));
  var v = parseInt(strMeshcoe.slice(5, 6));
  var r = parseInt(strMeshcoe.slice(6, 7));
  var w = parseInt(strMeshcoe.slice(7, 8));

  let lat_p, lon_p;
  let lat = p / 1.5 + q / 12 + r / 120;
  let lon = u + 100 + v * 0.125 + w * 0.0125;

  if (year1_nihonsokuchi > 0) {
    lat_p = lat;
    lon_p = lon;
    lat = lat_p - 0.00010695 * lat_p + 0.000017464 * lon_p + 0.0046017;
    lon = lon_p - 0.000046038 * lat_p - 0.000083043 * lon_p + 0.01004;
  }

  const latc = lat + 0.008333333 / 2;
  const lonc = lon + 0.0125 / 2;

  // var lat = 0;
  // var lon = 0;
  // var latc = 0;
  // var lonc = 0;
  // var lat_p = 0;
  // var lon_p = 0;

  // if(year1_nihonsokuchi>0){
  //   lat_p = p / 1.5 + q / 12 + r / 120;
  //   lon_p = u + 100 + v * 0.125 + w * 0.0125;
  //   lat =  lat_p - 0.00010695 * lat_p + 0.000017464 * lon_p + 0.0046017;
  //   lon = lon_p - 0.000046038 * lat_p - 0.000083043 * lon_p + 0.01004;
  //   latc = lat + 0.008333333 / 2;
  //   lonc = lon + 0.0125 / 2;
  // } else {
  //   lat = p / 1.5 + q / 12 + r / 120;
  //   lon = u + 100 + v * 0.125 + w * 0.0125;
  //   latc = lat + 0.008333333 / 2;
  //   lonc = lon + 0.0125 / 2;
  // }

  var alphatmp = alpha || 1;

  // var latc = latcpre.toPrecision(6)
  // var lonc = loncpre.toPrecision(6)

  var color1;
  if (c >= shikii1) {
    color1 = hanrei1_color;
    // color1 = "#67ADDF";
  } else if (c >= shikii2) {
    color1 = hanrei2_color;
  } else if (c >= shikii3) {
    color1 = hanrei3_color;
  } else if (c >= shikii4) {
    color1 = hanrei4_color;
  } else {
    color1 = hanrei5_color || hanrei4_color;
  }

  var ans_entities = {
    parent: dataname,
    // id:meshcode3rd ,
    // description : "<p>"+meshcode3rd+"</p><p>"+h+"</p><p>"+c+"</p>",
    name: lonc + "," + latc + "," + meshcode3rd + "," + h + "," + c,
    rectangle: {
      coordinates: Rectangle.fromDegrees(
        lon,
        lat,
        lon + 0.0125,
        lat + 0.008333333
      ),
      height: 0,
      extrudedHeight: h * defaultratio * ratio,
      material: Color.fromCssColorString(color1).withAlpha(alphatmp),
      // material : Color.fromRgba( color_gbra )
      outline: true,
      outlineColor: "white",
      outlineWidth: 1,
      // shadows : ShadowMode.ENABLED
    },
  };
  return ans_entities;
}
/// ///////////////////////// 3次メッシュ3列の可視化 ///
